<div class="error">
  <span>{{ message || "La page ou le projet demandé n'existe plus." }}</span>
  <a *ngIf="errorLink" [href]="errorLink">Accéder à mon projet</a>
</div>
